import React from "react";

const GooglePlayBadgeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="193"
    height="58"
    viewBox="0 0 193 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.714316"
      y="0.714316"
      width="191.437"
      height="55.7166"
      rx="6.42884"
      fill="black"
    />
    <rect
      x="0.714316"
      y="0.714316"
      width="191.437"
      height="55.7166"
      rx="6.42884"
      stroke="#A6A6A6"
      strokeWidth="1.42863"
    />
    <path
      d="M97.3413 31.0743C93.9811 31.0743 91.2424 33.6301 91.2424 37.1503C91.2424 40.649 93.9811 43.2262 97.3413 43.2262C100.703 43.2262 103.442 40.649 103.442 37.1503C103.44 33.6301 100.701 31.0743 97.3413 31.0743ZM97.3413 40.8347C95.4998 40.8347 93.9125 39.3161 93.9125 37.1517C93.9125 34.9645 95.5012 33.4687 97.3413 33.4687C99.1828 33.4687 100.77 34.9645 100.77 37.1517C100.77 39.3146 99.1828 40.8347 97.3413 40.8347ZM84.035 31.0743C80.6748 31.0743 77.9362 33.6301 77.9362 37.1503C77.9362 40.649 80.6748 43.2262 84.035 43.2262C87.3966 43.2262 90.1352 40.649 90.1352 37.1503C90.1352 33.6301 87.3966 31.0743 84.035 31.0743ZM84.035 40.8347C82.1935 40.8347 80.6063 39.3161 80.6063 37.1517C80.6063 34.9645 82.1949 33.4687 84.035 33.4687C85.8765 33.4687 87.4637 34.9645 87.4637 37.1517C87.4651 39.3146 85.8765 40.8347 84.035 40.8347ZM68.2086 32.9401V35.5173H74.3774C74.1931 36.9674 73.7103 38.026 72.9731 38.7618C72.0759 39.6589 70.6716 40.649 68.2086 40.649C64.4113 40.649 61.4426 37.5874 61.4426 33.7901C61.4426 29.9928 64.4113 26.9313 68.2086 26.9313C70.2573 26.9313 71.753 27.737 72.8574 28.7728L74.676 26.9541C73.1331 25.4812 71.0859 24.354 68.2086 24.354C63.007 24.354 58.6339 28.5885 58.6339 33.7901C58.6339 38.9918 63.007 43.2262 68.2086 43.2262C71.0159 43.2262 73.1345 42.3048 74.7903 40.579C76.4932 38.876 77.0233 36.4817 77.0233 34.5487C77.0233 33.9515 76.9775 33.3987 76.8847 32.9387H68.2086V32.9401ZM132.937 34.9416C132.431 33.5844 130.888 31.0743 127.735 31.0743C124.605 31.0743 122.004 33.5373 122.004 37.1503C122.004 40.5561 124.582 43.2262 128.034 43.2262C130.818 43.2262 132.43 41.5233 133.098 40.5333L131.027 39.1518C130.337 40.1647 129.393 40.8318 128.034 40.8318C126.677 40.8318 125.71 40.2104 125.088 38.9903L133.213 35.6302L132.937 34.9416ZM124.651 36.9674C124.582 34.6187 126.47 33.423 127.828 33.423C128.887 33.423 129.784 33.953 130.084 34.7116L124.651 36.9674ZM118.046 42.8591H120.715V24.9997H118.046V42.8591ZM113.672 32.4329H113.581C112.982 31.7186 111.83 31.0743 110.382 31.0743C107.343 31.0743 104.559 33.7444 104.559 37.1745C104.559 40.5804 107.343 43.2277 110.382 43.2277C111.832 43.2277 112.982 42.5833 113.581 41.8476H113.672V42.7219C113.672 45.0463 112.429 46.2892 110.428 46.2892C108.793 46.2892 107.78 45.1163 107.366 44.1263L105.042 45.0934C105.709 46.7035 107.48 48.6836 110.428 48.6836C113.558 48.6836 116.205 46.8421 116.205 42.3533V31.4443H113.673V32.4329H113.672ZM110.612 40.8347C108.77 40.8347 107.229 39.2918 107.229 37.1745C107.229 35.033 108.77 33.4687 110.612 33.4687C112.429 33.4687 113.856 35.033 113.856 37.1745C113.856 39.2918 112.429 40.8347 110.612 40.8347ZM145.443 24.9997H139.056V42.8591H141.72V36.0931H145.442C148.396 36.0931 151.302 33.9544 151.302 30.5471C151.302 27.1398 148.398 24.9997 145.443 24.9997ZM145.512 33.6072H141.72V27.4856H145.512C147.505 27.4856 148.636 29.1356 148.636 30.5471C148.636 31.93 147.505 33.6072 145.512 33.6072ZM161.987 31.0429C160.057 31.0429 158.058 31.8929 157.231 33.7773L159.597 34.7644C160.102 33.7773 161.045 33.4544 162.033 33.4544C163.411 33.4544 164.813 34.2816 164.836 35.7516V35.9359C164.353 35.6602 163.318 35.2473 162.055 35.2473C159.505 35.2473 156.908 36.6488 156.908 39.2675C156.908 41.6576 159 43.1962 161.343 43.1962C163.134 43.1962 164.123 42.3919 164.743 41.449H164.834V42.8276H167.409V35.9802C167.41 32.8115 165.041 31.0429 161.987 31.0429ZM161.664 40.8304C160.793 40.8304 159.574 40.3933 159.574 39.3132C159.574 37.9346 161.091 37.406 162.401 37.406C163.571 37.406 164.124 37.6589 164.836 38.0032C164.628 39.6589 163.204 40.8304 161.664 40.8304ZM176.783 31.4329L173.727 39.1761H173.636L170.464 31.4329H167.593L172.349 42.2548L169.637 48.275H172.417L179.748 31.4329H176.783ZM152.774 42.8591H155.438V24.9997H152.774V42.8591Z"
      fill="white"
    />
    <path
      d="M67.7429 14.6335C67.7429 15.8307 67.3886 16.7836 66.6786 17.495C65.8728 18.3408 64.8214 18.7636 63.5299 18.7636C62.2927 18.7636 61.2398 18.3351 60.3755 17.4779C59.5097 16.6193 59.0768 15.5564 59.0768 14.2877C59.0768 13.0177 59.5097 11.9548 60.3755 11.0976C61.2398 10.239 62.2927 9.81041 63.5299 9.81041C64.1442 9.81041 64.7314 9.93041 65.2885 10.169C65.8471 10.409 66.2943 10.7276 66.6286 11.1262L65.8757 11.8805C65.3085 11.2019 64.5271 10.8633 63.5285 10.8633C62.6256 10.8633 61.8455 11.1805 61.1869 11.8148C60.5283 12.4491 60.1997 13.2734 60.1997 14.2863C60.1997 15.2992 60.5283 16.1235 61.1869 16.7578C61.8455 17.3922 62.6256 17.7093 63.5285 17.7093C64.4856 17.7093 65.2842 17.3907 65.9228 16.7521C66.3371 16.3364 66.5772 15.7578 66.6414 15.0163H63.5285V13.9863H67.6815C67.7243 14.2106 67.7429 14.4263 67.7429 14.6335Z"
      fill="white"
    />
    <path
      d="M74.329 11.0534H70.426V13.7707H73.9462V14.8007H70.426V17.518H74.329V18.5723H69.3246V10.0005H74.329V11.0534Z"
      fill="white"
    />
    <path
      d="M78.9734 18.5723H77.8719V11.0534H75.4775V10.0005H81.3678V11.0534H78.9734V18.5723Z"
      fill="white"
    />
    <path
      d="M85.6293 18.5723V10.0005H86.7308V18.5723H85.6293Z"
      fill="white"
    />
    <path
      d="M91.6155 18.5723H90.514V11.0534H88.1196V10.0005H94.0099V11.0534H91.6155V18.5723Z"
      fill="white"
    />
    <path
      d="M105.16 17.4651C104.317 18.3308 103.27 18.7637 102.017 18.7637C100.764 18.7637 99.7169 18.3308 98.8755 17.4651C98.0326 16.5993 97.6126 15.5393 97.6126 14.2864C97.6126 13.0335 98.0326 11.9734 98.8755 11.1077C99.7169 10.2419 100.764 9.80762 102.017 9.80762C103.263 9.80762 104.309 10.2433 105.154 11.1134C106 11.9834 106.423 13.0406 106.423 14.2864C106.423 15.5393 106.002 16.5993 105.16 17.4651ZM99.6884 16.7465C100.323 17.3894 101.098 17.7094 102.017 17.7094C102.936 17.7094 103.713 17.3879 104.346 16.7465C104.98 16.1036 105.299 15.2836 105.299 14.2864C105.299 13.2892 104.98 12.4692 104.346 11.8263C103.713 11.1834 102.936 10.8634 102.017 10.8634C101.098 10.8634 100.323 11.1848 99.6884 11.8263C99.0555 12.4692 98.7369 13.2892 98.7369 14.2864C98.7369 15.2836 99.0555 16.1036 99.6884 16.7465Z"
      fill="white"
    />
    <path
      d="M107.969 18.5723V10.0005H109.309L113.475 16.6679H113.522L113.475 15.0164V10.0005H114.576V18.5723H113.426L109.067 11.5806H109.02L109.067 13.2321V18.5723H107.969Z"
      fill="white"
    />
    <g filter="url(#filter0_ii_574_1979)">
      <path
        d="M14.9092 10.7688C14.4935 11.2089 14.2477 11.8917 14.2477 12.7761V44.3717C14.2477 45.2574 14.4935 45.9389 14.9092 46.3789L15.0149 46.4818L32.7142 28.7825V28.5739V28.3653L15.0149 10.6646L14.9092 10.7688Z"
        fill="url(#paint0_linear_574_1979)"
      />
      <path
        d="M38.6131 34.6844L32.7142 28.7827V28.5742V28.3656L38.6145 22.4653L38.7473 22.541L45.7376 26.5126C47.7334 27.647 47.7334 29.5028 45.7376 30.6385L38.7473 34.6101L38.6131 34.6844Z"
        fill="url(#paint1_linear_574_1979)"
      />
      <g filter="url(#filter1_i_574_1979)">
        <path
          d="M38.7473 34.6083L32.7128 28.5737L14.9092 46.3788C15.5664 47.0759 16.6535 47.1617 17.8779 46.4673L38.7473 34.6083Z"
          fill="url(#paint2_linear_574_1979)"
        />
      </g>
      <path
        d="M38.7473 22.5394L17.8779 10.6818C16.6535 9.98604 15.5664 10.0732 14.9092 10.7704L32.7142 28.5754L38.7473 22.5394Z"
        fill="url(#paint3_linear_574_1979)"
      />
    </g>
    <defs>
      <filter
        id="filter0_ii_574_1979"
        x="14.2477"
        y="10.2017"
        width="32.9868"
        height="36.7451"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.214295" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_574_1979"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.214295" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_574_1979"
          result="effect2_innerShadow_574_1979"
        />
      </filter>
      <filter
        id="filter1_i_574_1979"
        x="14.9092"
        y="28.5737"
        width="23.8381"
        height="18.2699"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.429437" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_574_1979" />
      </filter>
      <linearGradient
        id="paint0_linear_574_1979"
        x1="31.1479"
        y1="12.4329"
        x2="6.55884"
        y2="36.9983"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.0066" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_574_1979"
        x1="48.3433"
        y1="28.5746"
        x2="13.7511"
        y2="28.5746"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_574_1979"
        x1="35.4663"
        y1="32.1364"
        x2="2.45408"
        y2="65.1486"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_574_1979"
        x1="10.4182"
        y1="0.0215403"
        x2="25.1484"
        y2="14.7517"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);

export default GooglePlayBadgeIcon;
